import { render, staticRenderFns } from "./ServiceDescription.vue?vue&type=template&id=288a9f21&scoped=true"
import script from "./ServiceDescription.vue?vue&type=script&lang=js"
export * from "./ServiceDescription.vue?vue&type=script&lang=js"
import style0 from "./ServiceDescription.vue?vue&type=style&index=0&id=288a9f21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288a9f21",
  null
  
)

export default component.exports